var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cancel_32px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 32,
    height: 32,
    rx: 16,
    fill: "#deebfe",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancel_24px",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M130.291,128.228l5.775-5.775A1.46,1.46,0,0,0,134,120.386l-5.775,5.775-5.775-5.775a1.461,1.461,0,1,0-2.067,2.067l5.775,5.775L120.386,134a1.461,1.461,0,1,0,2.067,2.067l5.775-5.775L134,136.07A1.461,1.461,0,0,0,136.07,134Z",
    transform: "translate(-116.228 -116.228)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.1c64558626c056bb177649449ef80bc0.svg";
export { ForwardRef as ReactComponent };